import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/forms/templates/new')({
  beforeLoad: () => {
    throw redirect({ to: '/template-engine/templates/new', replace: true });
  },
});
